import React from 'react';
export var Item = React.forwardRef(function Item(props, innerRef) {
    var className = props.className, Component = props.component, item = props.item, onClickHandler = props.onClickHandler, onSelectHandler = props.onSelectHandler, selected = props.selected, style = props.style;
    var selectItem = function () { return onSelectHandler(item); };
    return (React.createElement("li", { className: "rta__item " + (className || ''), style: style },
        React.createElement("button", { className: "rta__entity " + (selected ? 'rta__entity--selected' : ''), onClick: onClickHandler, onFocus: selectItem, onMouseEnter: selectItem, ref: innerRef },
            React.createElement(Component, { entity: item, selected: selected }))));
});
